export const MINUTE_IN_MS = 60_000;
export const HOUR_IN_MS = 3_600_000;
export const DAY_IN_MS = 86_400_000; // 1000 * 60 * 60 * 24
export const MONTH_IN_MS = 2_592_000_000; // 1day * 30
export const YEAR_IN_MS = 31_536_000_000; // 1day * 365
